import type { Lead } from '../types';

const labels: Record<Lead['status'], string> = {
  novo: 'Novo', contato: 'Em contato', qualificado: 'Qualificado', proposta: 'Proposta', ganho: 'Ganho', perdido: 'Perdido',
};

export function StatusPill({ status }: { status: Lead['status'] }) {
  return <span className={`pill pill--${status}`}>{labels[status]}</span>;
}

